import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dfad6db8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex flex-column justify-center items-center ion-padding can-animate",
  id: "animate"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/images/call_room_fulllogo.png",
      alt: "logo",
      class: "logo-img"
    }),
    /*#__PURE__*/_createElementVNode("div", {
      class: "slogan text-grey",
      id: "animate-after"
    }, [
      /*#__PURE__*/_createTextVNode(" Atletica "),
      /*#__PURE__*/_createElementVNode("div", { class: "mybold" }, " Emilia Romagna ")
    ])
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wrapper-text flex flex-column justify-center items-center ion-padding" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-container" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "title bold text-blue" }, "Profilo atleta digitale"),
      /*#__PURE__*/_createElementVNode("div", { class: "subtitle text-grey" }, " Riceverai una notifica per ogni iscrizione e per gli aggiornamenti degli orari direttamente nell'app di CallRoom. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "wrapper-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/images/slide-3.png",
      alt: "illustrazione iscrizioni",
      class: ""
    })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wrapper-text flex flex-column justify-center items-center ion-padding" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-container" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "title bold text-blue" }, "Trova gli eventi"),
      /*#__PURE__*/_createElementVNode("div", { class: "subtitle text-grey" }, " Cerca la tua prossima gara in base alle tue esigenze: grazie a CallRoom potrai cercare per gara, fascia oraria, numero di corsie della pista e tanto altro. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "wrapper-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/images/slide-1.png",
      alt: "illustrazione iscrizioni",
      class: ""
    })
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wrapper-text flex flex-column justify-center items-center ion-padding" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-container" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "title bold text-blue" }, "Tutti gli impianti"),
      /*#__PURE__*/_createElementVNode("div", { class: "subtitle text-grey" }, " Scopri dove e quando puoi allenarti: su CallRoom troverai tutti gli impianti in regione dove poter fare atletica con indicati gli orari di apertura, la presenza di parcheggio e altre informazioni utili. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "wrapper-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/images/slide-2.png",
      alt: "illustrazione iscrizioni",
      class: ""
    })
  ])
], -1))
const _hoisted_5 = { class: "flex flex-column justify-center items-center ion-padding" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title bold text-blue enter-callroom" }, "Entra in CallRoom!", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle text-grey" }, " Noi siamo pronti, e tu? ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_ctx.swipVisible)
    ? (_openBlock(), _createBlock(_component_ion_content, {
        key: 0,
        fullscreen: "",
        class: "swiper-content-crer bg-white-main"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_swiper, {
            modules: _ctx.modules,
            "slides-per-view": 1,
            "space-between": 50,
            pagination: { clickable: true },
            onSwiper: _ctx.onSwiper,
            onSlideChange: _ctx.onSlideChange,
            class: "w-full h-full ion-padding"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _hoisted_8,
                      _createElementVNode("div", {
                        class: "wrapper-cta",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSkipSwiper()))
                      }, [
                        _createVNode(_component_ion_icon, {
                          class: "cta",
                          icon: _ctx.chevronForwardCircleOutline
                        }, null, 8, ["icon"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modules", "onSwiper", "onSlideChange"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}